import LoadableContainer from '@components/LoadableContainer';
import { Card, Skeleton, Tag } from 'antd';
import React from 'react';
import { shortenString } from '@utils/string.util';
import { StudioPhoto } from '@core/models';
import RenderStudioPhotoStatus from './RenderStudioPhotoStatus';
import { MIDDLE_STYLE } from '@constants/responsive';

type ImageCardItemProps = {
  item: StudioPhoto;
  isSelected?: boolean;
  loading?: boolean;
  onClick: (item: StudioPhoto) => void;
};

const ImageBanner = ({ item }: { item: StudioPhoto }) => {
  return (
    <div
      style={{
        background: `url("${item.url}")`,
        height: 200,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        padding: '10px 20px',
        ...MIDDLE_STYLE,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        fontWeight: 'bold',
      }}>
      <RenderStudioPhotoStatus studioPhoto={item} />
    </div>
  );
};

const StudioImageItemCard = ({ item, loading, isSelected, onClick }: ImageCardItemProps) => {
  return (
    <Card
      onClick={() => onClick(item)}
      hoverable
      cover={<ImageBanner item={item} />}
      style={{
        maxWidth: 350,
        paddingTop: 30,
        minWidth: 300,
        width: '32%',
        marginRight: 10,
        marginBottom: 10,
        overflow: 'hidden',
        ...(isSelected ? { border: '2px solid #4096ff' } : {}),
      }}>
      <div>
        <LoadableContainer isLoading={loading || false} loadComponent={<Skeleton />}>
          <LoadableContainer
            isLoading={item.labels.length === 0 && item.description.length === 0}
            loadComponent={<div>No information</div>}>
            <React.Fragment>
              {(item.labels.length <= 6 ? item.labels : item.labels.slice(0, 6).concat('...')).map(
                label => (
                  <Tag color="blue" style={{ margin: '5px' }}>
                    {label}
                  </Tag>
                )
              )}
              <p style={{ marginTop: 20 }}>{shortenString(item.description || '', 100)}</p>
            </React.Fragment>
          </LoadableContainer>
        </LoadableContainer>
      </div>
    </Card>
  );
};

export default StudioImageItemCard;
